import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const faqItems = [
  {
    question: "Who is this for?",
    answer:
      "Panties Without Strings is for people working in the adult industry who want a free pair of clean underwear. You don't have to prove anything. If this is for you, it's for you.",
  },
  {
    question: "Why underwear?",
    answer:
      "Because basics matter. Clean underwear is practical, personal, and often overlooked. It's a small thing—but it's a dignified, no-strings way to offer support and open the door to listening.",
  },
  {
    question: "Is this really free? What's the catch?",
    answer:
      "Yes. No purchase. No required signup. No obligation to stay in touch. You can take the underwear and never hear from us again if that's what you want.",
  },
  {
    question: "Do I have to give my real name or legal identity?",
    answer:
      "No. We do not require legal names, stage names, ID, proof of work, or social media handles.",
  },
  {
    question: "What information do you collect—and why?",
    answer:
      "We collect the minimum necessary to send underwear. Everything else is optional and used only to understand how to better support workers in aggregate.",
  },
  {
    question: "Will my information be shared with anyone?",
    answer:
      "No. We don't sell data. We don't share data with platforms or law enforcement. We don't share identifiable data with funders or partners.",
  },
  {
    question: "Is this connected to Safe Work Coalition?",
    answer:
      "Yes. Panties Without Strings is a campaign of Safe Work Coalition.",
  },
  {
    question: "Will you contact me after this?",
    answer:
      "Only if you opt in. If you don't opt in, we won't follow up.",
  },
  {
    question: "Can I opt out or disappear later?",
    answer: "Yes. Always. No explanation required.",
  },
  {
    question: "Is this a rescue or exit program?",
    answer:
      "No. We believe adult industry workers deserve safety, autonomy, dignity, and support on their own terms.",
  },
  {
    question: "How often can I request underwear?",
    answer:
      "At launch: one per person so we can reach as many workers as possible.",
  },
  {
    question: "What if I have feedback or concerns?",
    answer:
      "Use the contact page. We welcome feedback and want to improve.",
  },
];

export default function FAQ() {
  return (
    <div className="bg-[color:var(--pws-off)] min-h-[calc(100vh-80px)] py-12 md:py-16">
      <div className="container-pws">
        <div className="max-w-3xl mx-auto">
          <h1
            className="font-['Space_Grotesk'] text-3xl sm:text-4xl font-semibold text-[color:var(--pws-charcoal)] tracking-tight"
            data-testid="faq-title"
          >
            Frequently Asked Questions
          </h1>
          <p className="mt-3 text-[color:var(--pws-stone)]">
            Common questions about Panties Without Strings.
          </p>

          <Accordion
            type="single"
            collapsible
            className="mt-8 space-y-4"
            data-testid="faq-accordion"
          >
            {faqItems.map((item, index) => (
              <AccordionItem
                key={index}
                value={`faq-${index}`}
                className="bg-white border border-[color:var(--pws-line)] rounded-lg px-6 data-[state=open]:shadow-sm"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="text-left font-medium text-[color:var(--pws-charcoal)] hover:text-[color:var(--pws-plum)] py-4">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-[color:var(--pws-ink)] pb-4">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-12 text-center">
            <p className="text-[color:var(--pws-stone)] mb-4">
              Have more questions?
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Button
                asChild
                className="bg-[color:var(--pws-plum)] hover:bg-[color:var(--pws-plum-hover)] text-white"
                data-testid="faq-contact-btn"
              >
                <Link to="/contact">Contact Us</Link>
              </Button>
              <Button
                asChild
                variant="outline"
                className="border-[color:var(--pws-line)]"
                data-testid="faq-pledge-btn"
              >
                <Link to="/pledge">Read Our Data Pledge</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
